import React, { useEffect } from "react";
import GalleryBanner from "../components/gallery/GalleryBanner";
import { useLoader } from "../context/LoaderContext";
// import GalleryGrid from "../components/gallery/GalleryGrid";
import AlbumsGrid from "../components/gallery/AlbumsGrid";
import { dynamicFailed } from "../hooks/useToast";
import { fetchGalleryBanner, fetchGalleryImage } from "../api/GalleryApi";
import {
  useGalleryBannerContext,
  useGalleryImageContext,
} from "../context/GalleryContext";

const Gallery = () => {
  const { setLoading } = useLoader();
  const { setGalleryBannerData } = useGalleryBannerContext();
  const { setGalleryImageData } = useGalleryImageContext();
  useEffect(() => {
    Promise.all([fetchGalleryBanner(), fetchGalleryImage()])
      .then(([GalleryBannerData, GalleryImageData]) => {
        setGalleryBannerData(GalleryBannerData);
        setGalleryImageData(GalleryImageData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        dynamicFailed(error.response.data.error.message);
      });
  }, [setGalleryBannerData, setGalleryImageData, setLoading]);
  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
      >
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div className="inner">
            <div className="inner_wrapper">
              <div className="sidebar_content full_width custom-sidebar_content">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id="785"
                  className="elementor elementor-785"
                  data-elementor-settings="[]"
                >
                  <div className="elementor-inner">
                    <div className="elementor-section-wrap">
                      <GalleryBanner />
                      {/* <GalleryGrid/> */}
                      <AlbumsGrid />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
};

export default Gallery;
